module.exports = __webpack_public_path__ + "img/app_activites.945199d1.svg";